export class ClientBase {
  protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    options.credentials = 'same-origin'
    // todo options.headers['Accept-Language'] = 'ru'
    return Promise.resolve(options)
  }

  protected transformResult = async <T>(url: string, response: Response, processResponse: (response: Response) => Promise<T>): Promise<T> =>
    processResponse(response)
}